import { PhasrRecommendationsGridWebComponent } from './component/PhasrRecommendationsGridWebComponent';
import { WEB_COMPONENT_PHASR_RECOMMENDATIONS_GRID } from '../../webcomponents.constants';

export { PhasrRecommendationsGridWebComponent };

window.customElements.define(WEB_COMPONENT_PHASR_RECOMMENDATIONS_GRID, PhasrRecommendationsGridWebComponent);
